import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { BRAND_NAME } from "../../lib/constants";

type Titles = { ru: string; en: string };

const TITLES: Array<[RegExp, Titles]> = [
  [/^\/login/, { ru: "Вход", en: "Sign in" }],
  [/^\/register/, { ru: "Регистрация", en: "Sign up" }],
  [
    /^\/(forgot|reset)-password/,
    { ru: "Восстановление пароля", en: "Password recovery" },
  ],
  [/^\/steam-callback/, { ru: "Подключение Steam", en: "Steam connection" }],
  [/^\/terms/, { ru: "Условия использования", en: "Terms of service" }],
  [/^\/privacy/, { ru: "Конфиденциальность", en: "Privacy policy" }],
  [/^\/match\//, { ru: "Матч", en: "Match" }],
  [/^\/profile\/.+/, { ru: "Профиль игрока", en: "Player profile" }],
  [/^\/settings/, { ru: "Настройки профиля", en: "Profile settings" }],
  [/^\/profile/, { ru: "Профиль", en: "Profile" }],
  [/^\/stats/, { ru: "Статистика", en: "Statistics" }],
  [/^\/inventory/, { ru: "Инвентарь", en: "Inventory" }],
  [/^\/clans/, { ru: "Кланы", en: "Clans" }],
  [/^\/subscription/, { ru: "Премиум", en: "Premium" }],
  [/^\/referral/, { ru: "Рефералка", en: "Referral" }],
  [/^\/support/, { ru: "Поддержка", en: "Support" }],
  [/^\/admin/, { ru: "Администрирование", en: "Admin" }],
];

export default function RouteTitle({ authenticated }: { authenticated: boolean }) {
  const { pathname } = useLocation();
  const { language } = useLanguage();
  useEffect(() => {
    document.documentElement.lang = language;
    const hit = TITLES.find(([re]) => re.test(pathname));
    let title = hit ? hit[1][language] : undefined;
    if (!title && pathname === "/") {
      title = authenticated
        ? language === "ru"
          ? "Играть"
          : "Play"
        : undefined;
    }
    document.title = title ? `${title} · ${BRAND_NAME}` : BRAND_NAME;
  }, [pathname, language, authenticated]);
  return null;
}
